var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsDateString, IsEnum, IsNumber, IsObject, IsOptional, IsUUID, } from 'class-validator';
import { Exclude, Expose, Type } from 'class-transformer';
import { TrainingReminderTime } from '../enums/training-reminder-time.enum.js';
import { UserProfileDto } from './user.profile.dto.js';
export class UserSettingsFullSizeDto {
    id;
    createdAt;
    updatedAt;
    userId;
    user;
    systemNotificationRegistrationEnabled;
    systemNotificationShopEnabled;
    systemNotificationPatientHandOverEnabled;
    systemNotificationAppointmentEnabled;
    systemNotificationExerciseProgramEnabled;
    systemNotificationTrainingReminderEnabled;
    systemNotificationProgramStatsEnabled;
    systemNotificationInvoicesEnabled;
    emailNotificationRegistrationEnabled;
    emailNotificationShopEnabled;
    emailNotificationPatientHandOverEnabled;
    emailNotificationAppointmentEnabled;
    emailNotificationExerciseProgramEnabled;
    emailNotificationTrainingReminderEnabled;
    emailNotificationProgramStatsEnabled;
    emailNotificationInvoicesEnabled;
    pushNotificationRegistrationEnabled;
    pushNotificationShopEnabled;
    pushNotificationPatientHandOverEnabled;
    pushNotificationAppointmentEnabled;
    pushNotificationExerciseProgramEnabled;
    pushNotificationTrainingReminderEnabled;
    pushNotificationProgramStatsEnabled;
    pushNotificationInvoicesEnabled;
    trainingReminderTime;
    defaultVideoCallDuration;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], UserSettingsFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], UserSettingsFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], UserSettingsFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], UserSettingsFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    __metadata("design:type", Function)
], UserSettingsFullSizeDto.prototype, "user", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "systemNotificationRegistrationEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "systemNotificationShopEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "systemNotificationPatientHandOverEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "systemNotificationAppointmentEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "systemNotificationExerciseProgramEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "systemNotificationTrainingReminderEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "systemNotificationProgramStatsEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "systemNotificationInvoicesEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "emailNotificationRegistrationEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "emailNotificationShopEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "emailNotificationPatientHandOverEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "emailNotificationAppointmentEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "emailNotificationExerciseProgramEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "emailNotificationTrainingReminderEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "emailNotificationProgramStatsEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "emailNotificationInvoicesEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "pushNotificationRegistrationEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "pushNotificationShopEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "pushNotificationPatientHandOverEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "pushNotificationAppointmentEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "pushNotificationExerciseProgramEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "pushNotificationTrainingReminderEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "pushNotificationProgramStatsEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UserSettingsFullSizeDto.prototype, "pushNotificationInvoicesEnabled", void 0);
__decorate([
    Expose(),
    IsEnum(TrainingReminderTime),
    __metadata("design:type", String)
], UserSettingsFullSizeDto.prototype, "trainingReminderTime", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], UserSettingsFullSizeDto.prototype, "defaultVideoCallDuration", void 0);
//# sourceMappingURL=user-settings.full-size.dto.js.map